<template>
			  <el-main class="index-main">

    		<!-- <bread-crumbs :title="title" class="bread-crumbs"></bread-crumbs> -->
		<router-view class="router-view" style="height:auto;background: transparent;"></router-view>
	</el-main>
</template>

<script>
	import menu from "@/utils/menu";
	export default {
		data() {
			return {
				menuList: [],
				role: "",
				currentIndex: -2,
				itemMenu: [],
				title: '',
			};
		},
		mounted() {
			let menus = menu.list();
			this.menuList = menus;
			this.role = this.$storage.get("role");
		},
		created() {
			this.init();
		},
		methods: {
			init(){
				this.$nextTick(()=>{
					// let h = document.getElementsByClassName('el-aside')[0].clientHeight
					// document.getElementsByClassName('el-main')[0].style.minHeight = "calc(100vh - 62px - " + h+'px)'
				})
			},
			menuHandler(menu) {
				this.$router.push({
					name: menu.tableName
				});
				this.title = menu.menu;
			},
			titleChange(index, menus) {
				this.currentIndex = index
				this.itemMenu = menus;
				console.log(menus);
			},
			homeChange(index) {
				this.itemMenu = [];
				this.title = ""
				this.currentIndex = index
				this.$router.push({
					name: 'home'
				});
			},
			centerChange(index) {
				this.itemMenu = [{
					"buttons": ["新增", "查看", "修改", "删除"],
					"menu": "修改密码",
					"tableName": "updatePassword"
				}, {
					"buttons": ["新增", "查看", "修改", "删除"],
					"menu": "个人信息",
					"tableName": "center"
				}];
				this.title = ""
				this.currentIndex = index
				this.$router.push({
					name: 'home'
				});
				
			}
		}
	};
</script>
<style lang="scss" scoped>
.index-main {
  // padding: 10px 20px;
  background-color: #f5f7fa;
  /* 根据头部高度 62px，保证主体足够撑满视口 */
  min-height: calc(100vh - 62px);
  box-sizing: border-box;

  .bread-crumbs {
    margin-bottom: 10px;
    background: #fff;
    padding: 10px 20px;
    border-radius: 4px;
  }

  .router-view {
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 4px;
    min-height: 400px; /* 视情况而定 */
  }
}
.el-main{
	padding: 67px 0 0;
	font-family: sans-serif;
}
</style>